<template>
  <div id="main" role="main">
    <div class="container">
      <figure class="logo" />
      <div class="content">
        <div class="inner" v-html="$t('subscriptions.cancel-subscription-reminders.confirmation-page-text')" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  beforeCreate: function () {
    document.getElementsByTagName('html')[0].classList.add('cancel-subscription-reminder')
  },
  created: async function () {
    const token = this.$route.params.token
    if (!token) {
      this.redirectToCatalog()
    }
    try {
      await this.$container.orderApiClient.cancelSubscriptionReminders(token)
    } catch (error) {
      this.redirectToCatalog()
    }
  },
  methods: {
    redirectToCatalog: function () {
      window.location.href = '/'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/CancelSubscriptionReminders.vue